import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  href: "#",
  class: "card border border-2 border-gray-300 border-hover"
}
const _hoisted_2 = { class: "card-header border-0 pt-9" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "symbol symbol-50px w-50px bg-light" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body p-9" }
const _hoisted_7 = { class: "fs-3 fw-bolder text-dark" }
const _hoisted_8 = { class: "text-gray-400 fw-bold fs-5 mt-1 mb-7" }
const _hoisted_9 = { class: "d-flex flex-wrap mb-5" }
const _hoisted_10 = { class: "\n            border border-gray-300 border-dashed\n            rounded\n            min-w-125px\n            py-3\n            px-4\n            me-7\n            mb-3\n          " }
const _hoisted_11 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "fw-bold text-gray-400" }, "Due Date", -1)
const _hoisted_13 = { class: "\n            border border-gray-300 border-dashed\n            rounded\n            min-w-125px\n            py-3\n            px-4\n            mb-3\n          " }
const _hoisted_14 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "fw-bold text-gray-400" }, "Budget", -1)
const _hoisted_16 = {
  key: 0,
  class: "symbol-group symbol-hover"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("a", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.icon,
            alt: "image",
            class: "p-3"
          }, null, 8, ["src"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", {
          class: [_ctx.getStatusDataBadgeColor, "badge fw-bolder me-auto px-4 py-3"]
        }, _toDisplayString(_ctx.getStatus), 3)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.title), 1),
      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.getDescription), 1),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.getDate), 1),
          _hoisted_12
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.getBudget), 1),
          _hoisted_15
        ])
      ]),
      _createVNode("div", {
        class: "h-4px w-100 bg-light mb-5",
        "data-bs-toggle": "tooltip",
        title: `This project ${_ctx.progress}% completed`
      }, [
        _createVNode("div", {
          class: [_ctx.getStatusDataColor, "rounded h-4px"],
          role: "progressbar",
          style: { width: _ctx.progress + `%` },
          "aria-valuenow": _ctx.progress,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, null, 14, ["aria-valuenow"])
      ], 8, ["title"]),
      (_ctx.users)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "symbol symbol-35px symbol-circle",
                "data-bs-toggle": "tooltip",
                title: user.title
              }, [
                (user.src)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      alt: "Pic",
                      src: user.src
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock("span", {
                      key: 1,
                      class: ["symbol-label fw-bolder", `bg-${user.state} text-inverse-${user.state}`]
                    }, _toDisplayString(user.initials), 3))
              ], 8, ["title"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}